import { useMutation, useQueryClient } from '@tanstack/react-query';

import { POADocumentType } from '@e-origin/shared';

import { request } from '@utils';
import { showErrorToast } from '@hooks/showErrorToast';

interface SendDocumentProps {
  importerId: string;
  type: POADocumentType;
}

export const useSendDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ importerId, type }: SendDocumentProps) => {
      await request({
        path: `importer/send-${type === POADocumentType.POA ? 'poa' : 'vat'}/${importerId}`,
        method: 'POST',
        authenticate: true,
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['importer', variables.importerId] });
    },
    onError: (error) => {
      showErrorToast(error, `Error sending document!`);
    },
  });
};
